<template>
  <b-card>
    <b-row align-h="between">
      <b-col>
        <h4>Catégories socioprofessionelles</h4>
      </b-col>
      <b-col cols="3" class="text-right">
        <b-avatar
          size="32"
          variant="light-primary"
          v-b-tooltip.hover.v-primary
          title="Cet indicateur illustre la répartition de la population selon leur catégorie socioprofessionnelle sur le secteur du programme ou adresse sélectionné au dernier recensement INSEE."
        >
          <feather-icon size="20" icon="HelpCircleIcon" />
        </b-avatar>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="7">
        <employment-division-chart
          :demographyByPeriode="reportData.demographyByPeriode[0]"
        />
      </b-col>
      <b-col xl="5">
        <employment-division-array
          :demographyByPeriode="reportData.demographyByPeriode[0]"
        />
      </b-col>
      <b-col xl="12">
        <comment-form-text-area
          :enable="reportData.comments.employmentDivision.enable"
          :commentField="reportData.comments.employmentDivision.value"
          v-on:update:comment="
            reportData.comments.employmentDivision.value = $event
          "
          v-on:update:enable="
            reportData.comments.employmentDivision.enable = $event
          "
          v-on="$listeners"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, VBTooltip, BAvatar } from "bootstrap-vue";
import EmploymentDivisionChart from "./employment-division-elements/EmploymentDivisionChart";
import EmploymentDivisionArray from "./employment-division-elements/EmploymentDivisionArray";
import CommentFormTextArea from "../../shared/CommentFormTextArea";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,

    // Components Vue
    EmploymentDivisionChart,
    EmploymentDivisionArray,
    CommentFormTextArea,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    reportData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.type-chart {
  width: 100%;
  height: 21rem;
}
</style>
